import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { Select } from '@/components/Select'
import { useInstitutionCampaignSelect } from '@/hooks/useInstitutionCampaignSelect'
import styles from './PedidosLayout.module.css'

export type PedidosLayoutOutletContext = {
  campaignId: number | null
  campaignsLoading: boolean
  hasCampaigns: boolean
}

export function PedidosLayout() {
  const {
    campaignOptions,
    campaignValue,
    handleCampaignValueChange,
    selectPlaceholder,
    campaignsLoading,
    campaignsError,
    persistError,
    isSelectorDisabled,
    campaignId,
  } = useInstitutionCampaignSelect()

  const outletContext = useMemo<PedidosLayoutOutletContext>(
    () => ({
      campaignId,
      campaignsLoading,
      hasCampaigns: campaignOptions.length > 0,
    }),
    [campaignId, campaignsLoading, campaignOptions.length]
  )

  const headerCampaign = (
    <div className={styles.campaignSelector}>
      <Select
        id="pedidos-campanha-select"
        value={campaignValue}
        onChange={handleCampaignValueChange}
        options={campaignOptions}
        placeholder={selectPlaceholder}
        label="Campanha"
        icon="mdi:bullhorn"
        disabled={isSelectorDisabled}
      />
      {campaignsError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {campaignsError}
        </p>
      ) : null}
      {persistError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {persistError}
        </p>
      ) : null}
    </div>
  )

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h1 className={styles.title}>Pedidos</h1>
          <p className={styles.subtitle}>
            Pedidos e pagamentos confirmados por campanha
          </p>
        </div>
        <div className={styles.headerActionWrap}>{headerCampaign}</div>
      </header>

      <div className={styles.content}>
        <Outlet context={outletContext} />
      </div>
    </div>
  )
}
